<template>
  <v-dialog
      v-model="dialog"
      persistent
      max-width="600"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
          small
          icon
          v-bind="attrs"
          v-on="on"
          @click="onOpen()"
      >
        <v-icon small icon>{{ icon }}</v-icon>
      </v-btn>
    </template>
    <v-sheet class="pt-5 px-3">
      <v-text-field
          v-model="direct_link"
          :label="$t('columns.direct_link')"
          dense
          outlined
      >
      </v-text-field>
    </v-sheet>
    <v-toolbar height="36">
      <v-spacer></v-spacer>
      <v-btn
          small
          @click="onCancel()"
      >
        {{ $t('cancel') }}
      </v-btn>
      <v-btn
          small
          class="ml-3"
          @click="onSave()"
          :disabled="!direct_link"
      >
        {{ $t('save') }}
      </v-btn>
    </v-toolbar>
  </v-dialog>
</template>

<script>

export default {
  name: 'LibraryVideoNewDialog',
  props: {
    value: {default: null},
    icon: {type: [String], default: 'mdi-image-area'},
  },

  components: {
  },

  computed: {
  },

  methods: {
    onOpen() {
      console.log('onOpen')
      this.direct_link = null
    },

    onCancel() {
      this.dialog = false
    },

    onSave() {
      // https://vimeo.com/377282759/bb770496b4
      // to
      // https://player.vimeo.com/video/377282759?h=bb770496b4
      if (this.direct_link.includes('player.vimeo.com')) {
        this.$emit('input', this.direct_link)
      }
      else {
        let vimeo_array = this.direct_link.split('/')
        let vimeo_url = 'https://player.vimeo.com/video/' + vimeo_array[vimeo_array.length - 2] + '?h=' + vimeo_array[vimeo_array.length - 1]
        this.$emit('input', vimeo_url)
      }
      this.dialog = false
    },

  },

  async mounted() {
  }
  ,

  data() {
    return {
      dialog: false,
      direct_link: null,
    }
  }
}
</script>

<style>
</style>

<i18n>
{
  "en": {
    "columns": {}
  },
  "de": {
    "columns": {}
  }
}
</i18n>
